import Vue from 'vue';

export default {
  async get() {
    try{
      console.log("requesting client info '/api/client'");
      var response = await Vue.http.get('/api/client');         
      console.log("requested client info '/api/client'");
      return response.data;
    }
    catch(e){
      console.log("failed to request client info", e);
    }
    
    return null;
  }
}



// WEBPACK FOOTER //
// ./_common/services/client.service.js